import React, { useEffect, useState } from 'react';
import "./ProfitOrLossCalculate.scss"
import { useAppContext } from '../../share-components/AppContext';
import { getProfitLossCalculateData } from '../../services/ManagementService';
import FormTitle from '../../share-components/FormTitle';
import { Card } from 'react-bootstrap';
import {
    getAvailableMonths, getChangingSelectColor, getInitialAndCurrentYearMonth, handleFromMonthChange, handleFromYearChange,
    handleToMonthChange, handleToYearChange, years
} from '../../services/UtilityService';
import { getAllActiveUsers } from '../../services/CommonService';
import { SERVER_ERROR_MESSAGE } from '../../constants/commonConstants';
import { ROUTE_PROFIT_LOSS_CALCULATE } from '../../constants/routeConstants';

const ProfitOrLossCalculate = () => {
    const { setLoading, setShowApiErrorMessage, setRouteNaviData } = useAppContext();

    const storeSessionKey = ROUTE_PROFIT_LOSS_CALCULATE;
    const initialSearchDataObj = sessionStorage.getItem(storeSessionKey);
    const initialSearchData = initialSearchDataObj ? JSON.parse(initialSearchDataObj) : null;

    const yearMonthInfo = getInitialAndCurrentYearMonth(4);
    const initialYear = yearMonthInfo?.fromYear;
    const initialMonth = yearMonthInfo?.fromMonth;

    const currentYear = yearMonthInfo?.toYear;
    const currentMonth = yearMonthInfo?.toMonth;

    const [fromYear, setFromYear] = useState(initialSearchData?.fromYear || initialYear);
    const [fromMonth, setFromMonth] = useState(initialSearchData?.fromMonth || initialMonth);
    const [toYear, setToYear] = useState(initialSearchData?.toYear || currentYear);
    const [toMonth, setToMonth] = useState(initialSearchData?.toMonth || currentMonth);
    const [targetYearMonth, setTargetYearMonth] = useState({
        fromYear,
        fromMonth,
        toYear,
        toMonth
    });

    const [dashboardData, setDashboardData] = useState(null);
    const [allActiveAdmin, setAllActiveAdmin] = useState([]);
    const [userCommonData, setUserCommonData] = useState([]);
    const [triggerPercentChange, setTriggerPercentChange] = useState(false);
    const [isFirstLoaded, setIsFirstLoaded] = useState(false);

    const getActiveAdmin = async () => {
        setLoading(true);
        try {
            const response = await getAllActiveUsers();
            const sorterdUsers = (response || [])?.sort((a, b) => (a.username || "")?.localeCompare((b?.username || "")));
            setAllActiveAdmin(sorterdUsers);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
            setLoading(false);
        }
    }

    const getCalculateData = async () => {
        setLoading(true);
        try {
            const formData = {
                fromYear: parseInt(fromYear),
                fromMonth: parseInt(fromMonth),
                toYear: parseInt(toYear),
                toMonth: parseInt(toMonth)
            }
            const response = await getProfitLossCalculateData(formData);
            setDashboardData(response);
            const targetYM = {
                fromYear,
                fromMonth,
                toYear,
                toMonth
            }
            setTargetYearMonth(targetYM);
            sessionStorage.setItem(storeSessionKey, JSON.stringify(targetYM));
            setIsFirstLoaded(true);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        setRouteNaviData("MANAGEMENT >> PROFIT/LOSS CALCULATE");
        getActiveAdmin();
        getCalculateData();
    }, []);

    useEffect(() => {
        let mergedUserData = [...allActiveAdmin || [], ...dashboardData?.paymentData || []].reduce((acc, appUser) => {
            let existingUser = acc.find(item => item.userId === appUser.userId);

            if (existingUser) {
                existingUser.purchasedAmount = (existingUser.purchasedAmount || 0) + (appUser.purchasedAmount || 0);
                existingUser.deliExpendAmount = (existingUser.deliExpendAmount || 0) + (appUser.deliExpendAmount || 0);
                existingUser.generalExpendAmount = (existingUser.generalExpendAmount || 0) + (appUser.generalExpendAmount || 0);
                existingUser.serviceChargeAmount = (existingUser.serviceChargeAmount || 0) + (appUser.serviceChargeAmount || 0);
                existingUser.tipMoneyAmount = (existingUser.tipMoneyAmount || 0) + (appUser.tipMoneyAmount || 0);
                existingUser.paymentReceivedAmount = (existingUser.paymentReceivedAmount || 0) + (appUser.paymentReceivedAmount || 0);
            } else {
                const purchasedAmount = parseInt(appUser.purchasedAmount) || 0;
                const deliExpendAmount = parseInt(appUser.deliExpendAmount) || 0;
                const generalExpendAmount = parseInt(appUser.generalExpendAmount) || 0;
                acc.push({
                    userId: appUser.userId,
                    username: appUser.username,
                    purchasedAmount: purchasedAmount,
                    deliExpendAmount: deliExpendAmount,
                    generalExpendAmount: generalExpendAmount,
                    serviceChargeAmount: parseInt(appUser.serviceChargeAmount) || 0,
                    tipMoneyAmount: parseInt(appUser.tipMoneyAmount) || 0,
                    paymentReceivedAmount: parseInt(appUser.paymentReceivedAmount) || 0,
                    profitPercentage: 100,
                    profitAmount: 0,
                    adjustedAmount: 0
                });
            }

            return acc || [];
        }, []);

        // const commonData = 
        setUserCommonData(mergedUserData);
        setTriggerPercentChange(prev => !prev);
    }, [dashboardData, allActiveAdmin]);

    const getProfitAmount = (totalProfit, totalPercentage, specificPercentage) => {
        const profitAmount = (((specificPercentage || 0) / (totalPercentage || 0)) * (totalProfit || 0)) || 0;
        return parseFloat(profitAmount?.toFixed(3)) || 0;
    };

    useEffect(() => {
        const totalPercent = userCommonData?.reduce((sum, item) => sum + (item.profitPercentage || 0), 0) || 0;
        const totalProfit = (totalpaymentReceivedAmount || 0) - (totalExpendedAmount || 0);
        setUserCommonData(prev => {
            return prev ? prev.map((data) => {
                const profit = (getProfitAmount(totalProfit, totalPercent, (data.profitPercentage || 0))) || 0;
                const adjustedAmount = (parseFloat((((data.purchasedAmount + data.deliExpendAmount + data.generalExpendAmount) - averageExpendedAmount) +
                    (averagePaymentReceivedAmount - data.paymentReceivedAmount) +
                    (profit - averageProfitAmount))?.toFixed(3))) || 0;
                return ({
                    ...data,
                    profitAmount: profit,
                    adjustedAmount: adjustedAmount
                })
            }
            ) : []
        });
    }, [triggerPercentChange]);

    // Calculate total and average
    const totalExpendedAmount = parseFloat(userCommonData?.reduce((sum, item) => sum + (item.purchasedAmount + item.deliExpendAmount + item.generalExpendAmount), 0)?.toFixed(3)) || 0;
    const averageExpendedAmount = parseFloat((userCommonData?.length > 0 ? totalExpendedAmount / userCommonData?.length : 0)?.toFixed(3)) || 0;
    const totalpaymentReceivedAmount = parseFloat((userCommonData?.reduce((sum, item) => sum + item.paymentReceivedAmount, 0))?.toFixed(3)) || 0;
    const averagePaymentReceivedAmount = parseFloat((userCommonData?.length > 0 ? totalpaymentReceivedAmount / userCommonData?.length : 0)?.toFixed(3)) || 0;
    const totalProfitAmount = parseFloat((totalpaymentReceivedAmount - totalExpendedAmount)?.toFixed(3)) || 0;
    const averageProfitAmount = parseFloat((userCommonData?.length > 0 ? totalProfitAmount / userCommonData?.length : 0)?.toFixed(3)) || 0;
    const totalProfitOrLoss = totalpaymentReceivedAmount - totalExpendedAmount;

    const handlePercentageChange = (userId, percentage) => {
        percentage = parseFloat(percentage);
        setUserCommonData(prev =>
            prev.map(appUser =>
                appUser.userId === userId
                    ? { ...appUser, profitPercentage: percentage }
                    : appUser  // Keep other users unchanged
            )
        );
        setTriggerPercentChange(prev => !prev);
    }

    const getMinusColor = (value) => {
        value = Number(value) || 0;
        return value < 0 ? 'text-danger fw-bold' : ''
    }

    const getFinalAdjustedResults = () => {
        const userInfos = (userCommonData || [])?.map(user => ({
            userId: user.userId,
            username: user.username,
            adjustedAmount: parseInt(user.adjustedAmount, 10) || 0
        }));

        const initialAdjustedInfos = userInfos?.map(user => {
            const adjustedInfos = userInfos
                .filter(other => other.userId !== user.userId) // exclude self
                .map(other => {
                    let mustPayOrReceive = 0;

                    // If both are positive (receivers) or both are negative (payers) → no transaction
                    if (
                        (user.adjustedAmount > 0 && other.adjustedAmount > 0) ||
                        (user.adjustedAmount < 0 && other.adjustedAmount < 0)
                    ) {
                        mustPayOrReceive = 0;
                    }
                    // If user is negative (payer) and other is positive (receiver)
                    else if (user.adjustedAmount < 0 && other.adjustedAmount > 0) {
                        mustPayOrReceive = Math.max(
                            -Math.min(Math.abs(user.adjustedAmount), other.adjustedAmount),
                            0
                        );
                        mustPayOrReceive = -Math.min(Math.abs(user.adjustedAmount), other.adjustedAmount);
                    }
                    // If user is positive (receiver) and other is negative (payer)
                    else if (user.adjustedAmount > 0 && other.adjustedAmount < 0) {
                        mustPayOrReceive = Math.min(user.adjustedAmount, Math.abs(other.adjustedAmount));
                    }

                    return {
                        userId: other.userId,
                        username: other.username,
                        mustPayOrReceive
                    };
                });

            return {
                userId: user.userId,
                username: user.username,
                adjustedInfos
            };
        });

        const paidInfos = dashboardData?.adjustmentInfos || [];

        const finalAdjustedResult = initialAdjustedInfos?.map(initialAdjustCalculatedInfo => {
            const beforePaidAdjustedAmount = parseInt(userInfos.find(user => user.userId === initialAdjustCalculatedInfo.userId)?.adjustedAmount, 10) || 0;
            const paymentPaidToOthersInfos = paidInfos.find(info => info.paidById === initialAdjustCalculatedInfo.userId)?.paymentAcceptedInfos;
            const result = {
                userId: initialAdjustCalculatedInfo?.userId,
                username: initialAdjustCalculatedInfo?.username,
                beforePaidAdjustedAmount: beforePaidAdjustedAmount,
                paymentPaidToOthersInfos: paymentPaidToOthersInfos,
                finalAdjustedInfos: initialAdjustCalculatedInfo?.adjustedInfos?.map(data => {
                    const paidAmount = parseInt(paymentPaidToOthersInfos?.find(info => info.acceptedById === data.userId)?.totalPaymentAmount) || 0;
                    const acceptedAmount = parseInt(paidInfos.find(info => info.paidById === data.userId)?.paymentAcceptedInfos
                        ?.find(accept => accept.acceptedById === initialAdjustCalculatedInfo.userId)?.totalPaymentAmount) || 0;

                    const finalAdjustment = {
                        userId: data.userId,
                        username: data.username,
                        afterPaidAmount: data.mustPayOrReceive + paidAmount - acceptedAmount
                    }
                    return finalAdjustment;
                })
            }
            return result;
        })

        return finalAdjustedResult;
    }


    return (
        <div id='profitOrLossCalculatePage'>
            <FormTitle title={"Profit/Loss Calculate"} isCenter={true} />
            {isFirstLoaded && <>
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                    {targetYearMonth?.fromYear}/{targetYearMonth?.fromMonth} ～ {targetYearMonth?.toYear}/{targetYearMonth?.toMonth}
                </div>
                <div style={{ overflow: "auto", paddingBottom: "50px" }}>
                    <div style={{ minWidth: "max-content", maxWidth: '650px', margin: '0 auto' }}>
                        <Card>
                            <Card.Body>
                                <div className='container' style={{ padding: '20px' }}>
                                    <div className="mb-1" style={{ display: "flex", gap: "10px", justifyContent: "start", alignItems: "end", flexWrap: "wrap" }}>
                                        <div className="d-inline">
                                            <label className="me-1 custom-label" htmlFor="fromYear" style={{ minWidth: "50px" }}>
                                                From
                                            </label>
                                            <div>
                                                <select
                                                    id="fromYear"
                                                    className={`customInputControl ${getChangingSelectColor(fromYear, targetYearMonth?.fromYear)}`}
                                                    value={fromYear}
                                                    onChange={(e) => handleFromYearChange(e, fromMonth, toYear, toMonth, setFromYear, setFromMonth, setToYear, setToMonth)}
                                                >
                                                    {years.map((year) => (
                                                        <option key={year} value={year}>{year}</option>
                                                    ))}
                                                </select>
                                                <span className="separator">/</span>
                                                <select
                                                    id="fromMonth"
                                                    className={`customInputControl ${getChangingSelectColor(fromMonth, targetYearMonth?.fromMonth)}`}
                                                    value={fromMonth}
                                                    onChange={(e) => handleFromMonthChange(e, fromYear, toYear, toMonth, setFromMonth, setToMonth)}
                                                >
                                                    {getAvailableMonths(fromYear).map((month) => (
                                                        <option key={month} value={month}>
                                                            {month.toString().padStart(2, "0")}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="d-inline">
                                            <label className="me-1 custom-label" htmlFor="toYear" style={{ minWidth: "50px" }}>
                                                To
                                            </label>
                                            <div>
                                                <select
                                                    id="toYear"
                                                    className={`customInputControl ${getChangingSelectColor(toYear, targetYearMonth?.toYear)}`}
                                                    value={toYear}
                                                    onChange={(e) => handleToYearChange(e, fromYear, fromMonth, toMonth, setFromYear, setToYear, setFromMonth)}
                                                >
                                                    {years.map((year) => (
                                                        <option key={year} value={year}>{year}</option>
                                                    ))}
                                                </select>
                                                <span className="separator">/</span>
                                                <select
                                                    id="toMonth"
                                                    className={`customInputControl ${getChangingSelectColor(toMonth, targetYearMonth?.toMonth)}`}
                                                    value={toMonth}
                                                    onChange={(e) => handleToMonthChange(e, fromYear, fromMonth, toYear, setFromMonth, setToMonth)}
                                                >
                                                    {getAvailableMonths(toYear).map((month) => (
                                                        <option key={month} value={month}>
                                                            {month.toString().padStart(2, "0")}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="d-inline">
                                        <div><button type='button' className="btn btn-success btn-sm appBtn"
                                            onClick={getCalculateData}
                                        >Calculate</button></div>
                                    </div>

                                    <div className='mt-2'>
                                        <div className='tbl-wrapper'>
                                            <div className="section-title">Profit/Loss</div>
                                            <table className='table table-bordered auto-width-table'>
                                                <thead>
                                                    <tr><th>Name</th><th>Profit/Loss</th><th>Percentage</th></tr>
                                                </thead>
                                                <tbody>
                                                    {userCommonData?.map((appUser, index) => (
                                                        <tr key={index}>
                                                            <td>{appUser.username}</td>
                                                            <td className={`${getMinusColor(appUser.profitAmount)}`}>{appUser.profitAmount}¥</td>
                                                            <td>
                                                                <input type="number"
                                                                    inputMode="numeric"  // forces numeric keypad on mobile
                                                                    pattern="[0-9]*"      // enforces only digits
                                                                    className='customInputControl clearNumberSpin'
                                                                    value={appUser.profitPercentage}
                                                                    style={{
                                                                        // width: 'inherit',
                                                                        minWidth: '60px',
                                                                        maxWidth: '70px'
                                                                    }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === "e" || e.key === "-" || e.key === "." || e.key === "+") {
                                                                            e.preventDefault(); // Prevent form submission
                                                                        }
                                                                    }}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    onChange={(e) => handlePercentageChange(appUser.userId, e.target.value)} />
                                                            </td>
                                                        </tr>
                                                    ))
                                                    }
                                                </tbody>
                                                <thead className='footer-header'>
                                                    <tr><th>Total {totalProfitOrLoss >= 0 ? "Profit" : "Loss"}</th><th colSpan={2} className={`${getMinusColor(totalProfitOrLoss)}`}>{totalProfitOrLoss}¥</th></tr>
                                                </thead>
                                            </table>
                                        </div>

                                        {/* <div className='tbl-wrapper'>
                                            <div className="section-title">Adjustment<br /><span style={{ color: 'blue' }}>※(-) Indicates the person must pay others.</span></div>
                                            <table className='table table-bordered auto-width-table'>
                                                <thead>
                                                    <tr><th>Name</th><th>Amount</th><th>Paid Payment</th><th>Final Adjustment</th></tr>
                                                </thead>
                                                <tbody>
                                                    {userCommonData?.map((appUser, index) => (
                                                        <tr key={index}>
                                                            <td>{appUser.username}</td>
                                                            <td className={`${getMinusColor(appUser.adjustedAmount)}`}>{appUser.adjustedAmount}¥</td>
                                                            <td>
                                                                {((dashboardData?.adjustmentInfos || []).find(adjustment => adjustment.paidById === appUser?.userId)
                                                                    ?.paymentAcceptedInfos || [])?.map(acceptedInfo => (
                                                                        <React.Fragment key={acceptedInfo?.acceptedById}><span>{'=>'}{acceptedInfo?.acceptedBy} ({acceptedInfo?.totalPaymentAmount}¥)</span><br /></React.Fragment>
                                                                    ))}
                                                            </td>
                                                            <td>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div> */}

                                        <div className='tbl-wrapper'>
                                            <div className="section-title">Adjustment<br /><span style={{ color: 'blue' }}>※(-) Indicates the person must pay others.</span></div>
                                            <table className='table table-bordered auto-width-table'>
                                                <thead>
                                                    <tr><th>Name</th><th>Final Adjustment</th><th>Initial Adjustment</th><th>Paid to</th></tr>
                                                </thead>
                                                <tbody>
                                                    {getFinalAdjustedResults()?.map((user, index) => (
                                                        <tr key={index}>
                                                            <td>{user.username}</td>
                                                            <td>
                                                                {user.finalAdjustedInfos?.map(finalAdj => (
                                                                    <React.Fragment key={finalAdj?.userId}>
                                                                        <span
                                                                            className={`${getMinusColor(finalAdj?.afterPaidAmount)}`}>
                                                                            {finalAdj?.username} ({finalAdj?.afterPaidAmount}¥)
                                                                        </span><br />
                                                                    </React.Fragment>
                                                                ))}
                                                            </td>
                                                            <td className={`${getMinusColor(user.beforePaidAdjustedAmount)}`}>{user.beforePaidAdjustedAmount}¥</td>
                                                            <td>
                                                                {user.paymentPaidToOthersInfos?.map(acceptedInfo => (
                                                                    <React.Fragment key={acceptedInfo?.acceptedById}>
                                                                        {(parseInt(acceptedInfo?.totalPaymentAmount) || 0) > 0 && <>
                                                                            <span>
                                                                                {acceptedInfo?.acceptedBy} {"ကို"} ({acceptedInfo?.totalPaymentAmount}¥) {"ပေးထားသည်။"}
                                                                            </span><br />
                                                                        </>}
                                                                    </React.Fragment>
                                                                ))}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>


                                        <div className='tbl-wrapper'>
                                            <div className="section-title">Expend</div>
                                            <table className='table table-bordered auto-width-table'>
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Total Expend</th>
                                                        <th>Purchase</th>
                                                        <th>Delivery</th>
                                                        <th>General Expend</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {userCommonData?.map((appUser, index) => (
                                                        <tr key={index}>
                                                            <td>{appUser.username}</td>
                                                            <td>{appUser.purchasedAmount + appUser.deliExpendAmount + appUser.generalExpendAmount}¥</td>
                                                            <td>{appUser.purchasedAmount}¥</td>
                                                            <td>{appUser.deliExpendAmount}¥</td>
                                                            <td>{appUser.generalExpendAmount}¥</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <thead className='footer-header'>
                                                    <tr><th>Total</th><th colSpan={4}>{totalExpendedAmount}¥</th></tr>
                                                    <tr><th>Average</th><th colSpan={4}>{averageExpendedAmount}¥</th></tr>
                                                </thead>
                                            </table>
                                        </div>

                                        <div className='tbl-wrapper'>
                                            <div className="section-title">Payment Received</div>
                                            <table className='table table-bordered auto-width-table'>
                                                <thead>
                                                    <tr><th>Name</th><th>Total Received</th><th>Service Charge</th><th>Tip Money</th></tr>
                                                </thead>
                                                <tbody>
                                                    {userCommonData?.map((appUser, index) => (
                                                        <tr key={index}>
                                                            <td>{appUser.username}</td>
                                                            <td>{appUser.paymentReceivedAmount}¥</td>
                                                            <td>{appUser.serviceChargeAmount}¥</td>
                                                            <td>{appUser.tipMoneyAmount}¥</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <thead className='footer-header'>
                                                    <tr><th>Total</th><th colSpan={3}>{totalpaymentReceivedAmount}¥</th></tr>
                                                    <tr><th>Average</th><th colSpan={3}>{averagePaymentReceivedAmount}¥</th></tr>
                                                </thead>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                        <Card style={{ padding: '20px', marginTop: '15px', background: '#a3a3a3' }}>
                            <Card.Body>
                                <div className="section-title">Pending Order Summary Info <br />(Not Include In Current Calculation)</div>
                                <table className='table table-bordered auto-width-table'>
                                    <thead>
                                        <tr><th>Info</th><th>Amount</th></tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Payment Received Amount</td>
                                            <td>{dashboardData?.pendingOrderInfo?.paymentReceivedAmount}¥</td>
                                        </tr>
                                        <tr>
                                            <td>Deli Fee</td>
                                            <td>{dashboardData?.pendingOrderInfo?.orderedDeliFee}¥</td>
                                        </tr>
                                        <tr>
                                            <td>Service Charge</td>
                                            <td>{dashboardData?.pendingOrderInfo?.orderedServiceCharge}¥</td>
                                        </tr>
                                        <tr>
                                            <td>Tip Money</td>
                                            <td>{dashboardData?.pendingOrderInfo?.orderedTipMoney}¥</td>
                                        </tr>
                                        <tr>
                                            <td>PR Gift Amount</td>
                                            <td>{dashboardData?.pendingOrderInfo?.orderedPRGiftAmount}¥</td>
                                        </tr>
                                        <tr>
                                            <td>Quantity</td>
                                            <td>{dashboardData?.pendingOrderInfo?.orderedQuantity}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Card.Body>
                        </Card>

                        <Card style={{ padding: '20px', marginTop: '15px', background: '#a3a3a3' }}>
                            <Card.Body>
                                <div className="section-title">Instock Summary Info <br />(Not Include In Current Calculation)</div>
                                <table className='table table-bordered auto-width-table'>
                                    <thead>
                                        <tr><th>Info</th><th>Amount</th></tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Instock Amount Without Profit</td>
                                            <td>{dashboardData?.instockInfo?.instockAmountWithoutProfit}¥</td>
                                        </tr>
                                        <tr>
                                            <td>Instock Amount With Profit</td>
                                            <td>{dashboardData?.instockInfo?.instockAmountWithProfit}¥</td>
                                        </tr>
                                        <tr>
                                            <td>Instock Quantity</td>
                                            <td>{dashboardData?.instockInfo?.instockQuantity}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
            </>}
        </div>
    );
};

export default ProfitOrLossCalculate;